import { z } from 'zod';
import {
  DEFAULT_PAGE_LIMIT,
  MAX_PAGE_LIMIT,
  MAX_CUSTOM_INSTRUCTIONS_LENGTH,
} from '../constants';

// File validation constants
export const ALLOWED_MIME_TYPES = ['image/png', 'image/jpeg'] as const;
export const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25MB

export const designFilterSchema = z.enum(['all', 'has_listing', 'no_listing', 'warnings']);
export const designSortSchema = z.enum(['created_at', 'updated_at']);
export const sortOrderSchema = z.enum(['asc', 'desc']);

export const designListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(MAX_PAGE_LIMIT).default(DEFAULT_PAGE_LIMIT),
  filter: designFilterSchema.default('all'),
  sort: designSortSchema.default('created_at'),
  order: sortOrderSchema.default('desc'),
});

export const customInstructionsSchema = z.string().max(MAX_CUSTOM_INSTRUCTIONS_LENGTH).optional();

export type DesignListQuery = z.infer<typeof designListQuerySchema>;
